// Cores de marca de terceiros. Não são do tema (não mudam por tema) — mas
// devem ser nomeadas e centralizadas, nunca repetidas inline.
export const brandColors = {
  whatsapp: {
    main: '#25D366',     // verde oficial WhatsApp
    bubble: '#e7ffdb',   // fundo do balão de pré-visualização
  },
};
